import { get } from 'lodash';

export function getUserScore(state) {
  return state.score;
}

export function getMyExperience(state, getters) {
  return get(getters.getUserScore, 'adjust_exp', 0);
}
